import React, { useEffect, useState } from 'react'
import type { CMSSectionProductCarousel } from '@/types/sanity'
import { Section } from '../Section'
import { ProductCardV2 } from '@components/Cards/ProductV2/Base'

import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper/modules'
import 'swiper/scss'
import 'swiper/scss/pagination'
import 'swiper/css/free-mode'
import 'swiper/scss/navigation'
import 'swiper/css/thumbs'
import 'swiper/css/navigation'

import styles from './SectionProductCarouselV2.module.scss'
import type { Bottomline } from '@/types/yotpo'
import { LinkButton } from '@/components/Link/LinkButton'

type SectionProductCarouselProps = {
  content: CMSSectionProductCarousel
}

export const SectionProductCarouselV2: React.FC<
  SectionProductCarouselProps
> = ({ content }) => {
  const [productBottomlinesMap, setProductBottomlinesMap] = useState<
    Record<string, Bottomline>
  >({})

  const {
    _id,
    heading,
    subtitle,
    cta,
    cardBackgroundColor,
    products,
    moduleCta,
  } = content

  useEffect(() => {
    const fetchProductBottomlines = async () => {
      const response = await fetch(
        `${window.location.origin}/api/yotpo-reviews`,
      )
      const data = await response.json()
      setProductBottomlinesMap(data)
    }

    fetchProductBottomlines()
  }, [])

  return (
    <Section id={_id} hasWrapper={true} theme={content.theme || 'milk-lighter'}>
      {products.length > 4 && (
        <>
          <div className={styles.prevButton}>
            <button
              className={`button button--transparentArrow`}
              type="button"
            ></button>
          </div>
          <div className={styles.nextButton}>
            <button
              className={`button button--transparentArrow`}
              type="button"
            ></button>
          </div>
        </>
      )}
      <div className={styles.container}>
        {(subtitle || heading || moduleCta) && (
          <div className={styles.header}>
            {(subtitle || heading) && (
              <div className={styles.headerText}>
                {subtitle && (
                  <p className={`${styles.subtitle} type-label`}>{subtitle}</p>
                )}
                {heading && (
                  <h2 className={`${styles.heading} type-h3 md:type-h5`}>
                    {heading}
                  </h2>
                )}
              </div>
            )}
            {moduleCta && (
              <LinkButton
                link={moduleCta}
                className={`${styles.headerButton} type-label`}
              />
            )}
          </div>
        )}
        <Swiper
          slidesPerView={1.5}
          spaceBetween={16}
          breakpoints={{
            768: {
              spaceBetween: 32,
              slidesPerView: 4,
            },
          }}
          loop={true}
          touchEventsTarget="container"
          modules={[Navigation]}
          navigation={{
            prevEl: `[data-section-id="${_id}"] .${styles.prevButton}`,
            nextEl: `[data-section-id="${_id}"] .${styles.nextButton}`,
          }}
        >
          {products.map((product, index) => {
            // TODO: Adding validation in Sanity
            if (!product.card) return null

            return (
              <SwiperSlide key={index}>
                <ProductCardV2
                  key={index}
                  content={product.card}
                  cta={cta}
                  backgroundColor={cardBackgroundColor || '#7272727'}
                  bottomline={productBottomlinesMap[product.card.id]}
                />
              </SwiperSlide>
            )
          })}
        </Swiper>
      </div>
    </Section>
  )
}
